<template>
  <v-col cols="12">
    <!-- Expansion panel 2.0 START -->
    <template>
      <v-fade-transition leave-absolute>
        <v-row no-gutters>
          <v-col cols="3">
            <v-text-field
              v-model="serie.name.defaultValue.value"
              label="Name"
              placeholder="Series name"
            ></v-text-field>
          </v-col>
          <v-spacer> </v-spacer>
        </v-row>
      </v-fade-transition>
    </template>
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Profiles</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-col cols="1">
        <v-btn small fab color="primary" @click="onAddSeriesNameProfile()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-toolbar>
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(profile, index) in serie.name.profileValues"
        :key="index"
      >
        <v-expansion-panel-header>
          <v-col cols="11">
            <span> {{ profile.value.value }} </span>
          </v-col>
          <v-col cols="1">
            <v-btn icon>
              <v-icon @click="onDeleteProfile(profile.value.value)"
                >mdi-close-thick</v-icon
              >
            </v-btn>
          </v-col>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row no-gutters>
            <v-col cols="4">
              <v-autocomplete
                :items="getProfileObjectTable"
                v-model="profile.id"
                item-value="id"
                item-text="value.value"
                label="profiles"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="profile.value.value"
                item-value="value.value"
                label="Name"
                placeholder="Series name"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- End of expansion panel 2.0 -->
    <v-row>
      <v-col cols="2">
        <p>Series type</p>
        <v-radio-group v-model="serie.type" mandatory>
          <v-radio label="Sighting" value="SIGHTING"></v-radio>
          <v-radio label="Match" value="MATCH"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="2">
        <p>Marking Monitor</p>
        <v-radio-group v-model="serie.marking[0].type" mandatory>
          <v-radio label="Open" value="OPEN"></v-radio>
          <v-radio label="Closed" value="CLOSED"></v-radio>
          <v-radio label="Manual" value="MANUAL"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="2">
        <p>Marking spectator</p>
        <v-radio-group v-model="serie.marking[1].type" mandatory>
          <v-radio label="Open" value="OPEN"></v-radio>
          <v-radio label="Closed" value="CLOSED"></v-radio>
          <v-radio label="Manual" value="MANUAL"></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model.number="serie.shots.count"
          type="number"
          label="Shot count"
        ></v-text-field>
      </v-col>

      <v-col cols="4" v-if="teamShootingEnabled">
        <p>Team shooting</p>
        <div>
          <v-checkbox
            v-model="serie.teamShootingSetup.multipleShooters"
            label="Multiple shooters"
          ></v-checkbox>
          <v-checkbox
            v-model="serie.teamShootingSetup.enableSighters"
            label="Enable sighters"
          ></v-checkbox>
        </div>
      </v-col>
    </v-row>
    
    <div class="grid-container">
    <!-- RE-SHOOTING RULES -->
      <v-select
      v-model="serie.reshootingRules"
      :items="reshootingRules"
      label="Re-shooting rules"
      item-value="value"
      item-text="text"
      multiple
      chips
    ></v-select>
    <!-- RE-SHOOTING PROCEDURE PROFILE -->
      <v-select
      v-model="serie.reshootingProcedureProfile"
      :items="reshootingProcedureProfiles"
      label="Re-shooting procedure profile"
      item-value="value"
      item-text="text"
      chips
    ></v-select>
    <!-- ALLOWED ACTIONS -->
    <v-select
      v-model="serie.allowedActions"
      :items="actionTypes"
      label="Allowed actions in serie"
      item-value="value"
      item-text="text"
      multiple
      chips
    >
    </v-select>
    </div>
    <!-- Radio buttons END -->
    <!-- Target score START -->
    <p>Target scoring template</p>
    <v-autocomplete
      v-model="serie.targetScoringDefinition[0]"
      :items="getTargetScoringTemplates()"
      :placeholder="this.getTargetDefinitionName()"
      item-text="targetScoringDefinition.name"
      item-value="targetScoringDefinition.id"
      rounded
      solo
    >
      <template v-slot:prepend-item>
        <v-row>
          <v-col>
            <span style="margin-left: 15px" class="align-self-center">
              Name</span
            >
          </v-col>
          <v-col>
            <span class="align-self-center">Visual Number</span>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </template>
      <template v-slot:item="{ item }">
        <v-row>
          <v-col>
            <span class="align-self-center">
              {{ item.targetScoringDefinition.name }}
            </span>
          </v-col>
          <v-col>
            <span class="align-self-center">
              {{ item.targetScoringDefinition.visualNumber }}
            </span>
          </v-col>
        </v-row>
      </template>
    </v-autocomplete>

    <!-- TARGET SCALING RELATED PROPERTIES -->
    <v-checkbox
      v-model="serie.targetScale.enabled"
      hide-details
      class="mt-0"
      label="Scale scoring definition"
    />

    <div class="d-flex flex-row pa-3" v-if="serie.targetScale.enabled">
      <v-text-field
        :rules="rules.positiveNonZeroIntegerNumber"
        v-model.number="serie.targetScale.nominalDistance"
        class="mx-3"
        label="Nominal"
        type="number"
        suffix="m"
        min="1"
      />

      <v-text-field
        :rules="rules.positiveNonZeroIntegerNumber"
        v-model.number="serie.targetScale.actualDistance"
        class="mx-3"
        label="Actual"
        type="number"
        suffix="m"
        min="1"
      />

      <v-text-field
        :value="scaleFactor(serie)"
        disabled
        class="mx-3"
        type="number"
        suffix="%"
      ></v-text-field>
    </div>
    <!-- Target score END -->
  </v-col>
</template>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  padding: 10px;
}
.grid-container div {
  padding: 10px;
}
</style>


<script>
// import * as helpers from '../../shootingProgramHelpers.js';
import {
  GET_REGISTERED_ACTION_TYPES,
  GET_REGISTERED_RESHOOTING_RULES,
  GET_REGISTERED_RESHOOTING_PROCEDURE_PROFILES
} from "../../../../graphql/shootingProgramQueries.js";
import { createSelectionTypeObject } from "../../../../utils/Helper.js";

export default {
  name: "EditSeriesGeneralPanel",
  props: {
    serie: Object,
    profiles: Array,
    scoringDefinitions: Array,
    teamShootingEnabled: Boolean,
  },
  data: () => ({
    actionTypes: [],
    reshootingRules: [],
    reshootingProcedureProfiles: [],
    rules: {
      positiveNonZeroIntegerNumber: [
        (v) => /^(0*[1-9]\d*)$/.test(v) || "Must be a positive integer",
      ],
    },
  }),
  created() {
    this.getRegistreredActionTypes();
    this.getReshootingRules();
    this.getReshootingProcedureProfiles();
  },
  apollo: {
    $client: "shootingProgramClient",
  },

  computed: {
    getProfileObjectTable() {
      var profileObjects = [];
      this.profiles.map((profile, index) => {
        profileObjects[index] = {
          value: {
            value: profile.name.value,
          },
          id: profile.id,
        };
      });

      return profileObjects;
    },
  },
  methods: {
    async getRegistreredActionTypes() {
      this.actionTypes = createSelectionTypeObject(
        await this.$apollo
          .query({
            query: GET_REGISTERED_ACTION_TYPES,
          })
          .then((response) => {
            return response.data.getRegistreredActionTypes; // Query returns an array, we take first element since we use specific ID
          })
          .catch((error) => {
            throw error;
          })
      );
    },
    async getReshootingRules() {
      this.reshootingRules = createSelectionTypeObject(
        await this.$apollo
          .query({
            query: GET_REGISTERED_RESHOOTING_RULES,
          })
          .then((response) => {
            return response.data.getReshootingRules; // Query returns an array, we take first element since we use specific ID
          })
          .catch((error) => {
            throw error;
          }), true
        );
    },
    async getReshootingProcedureProfiles() {
      this.reshootingProcedureProfiles = createSelectionTypeObject(
        await this.$apollo
          .query({
            query: GET_REGISTERED_RESHOOTING_PROCEDURE_PROFILES,
          })
          .then((response) => {
            return response.data.getReshootingProcedureProfiles; // Query returns an array, we take first element since we use specific ID
          })
          .catch((error) => {
            throw error;
          }), true
      );
    },
    getTargetDefinitionName() {
      if (this.serie.targetScoringDefinition.length != 0)
        return this.getTargetScoringName(
          this.serie.targetScoringDefinition[0].id
        );
      else return "";
    },
    getTargetScoringName(id) {
      let nameResult = "";
      this.getTargetScoringTemplates().map((target) => {
        if (target.targetScoringDefinition.id == id) {
          nameResult = target.targetScoringDefinition.name;
        }
      });
      return nameResult;
    },
    getTargetScoringTemplates() {
      return this.scoringDefinitions;
    },
    onAddSeriesNameProfile() {
      this.serie.name.profileValues.push({
        value: {
          value: this.serie.name.defaultValue.value,
        },
        id: "",
      });
    },

    onDeleteProfile(profileName) {
      this.serie.name.profileValues = this.serie.name.profileValues.filter(
        (profile) => profile.value.value !== profileName
      );
    },
    scaleFactor(serie) {
      return Math.round(
        100 *
          (serie.targetScale.actualDistance / serie.targetScale.nominalDistance)
      );
    },
  },
};
</script>
